









import { Vue, Component } from 'vue-property-decorator';
import { Toast } from 'vant';
import { saveComment } from '../api/api';
import { isWeiXin, getQueryString } from '@/common/ts/common';
@Component
export default class CommentInput extends Vue {
  voteName = '2019poject/2019new70years';
  content: string = '';
  async saveComment() {
    if (this.content) {
      const getTargetId = this.$route.query.locationId;
      if (isWeiXin()) {
        const getUnionid = window.localStorage.getItem('unionid');
        const nickname = window.localStorage.getItem('nickname');
        const headimgurl = window.localStorage.getItem('headimgurl');
        const res = await saveComment(this.voteName, {
          content: this.content,
          unionid: getUnionid,
          wxName: nickname,
          wxAvatar: headimgurl,
          targetId: getTargetId,
        });
        Toast((res as any).msg);
        if ((res as any).code === 200) {
          this.content = '';
        }
      } else if (window.udid) {
        const res = await saveComment(this.voteName, {
          content: this.content,
          udid: window.udid,
          appkey: window.appkey,
          targetId: getTargetId,
        });
        Toast((res as any).msg);
        if ((res as any).code === 200) {
          this.content = '';
        }
      } else {
        Toast('请在微信或者上游新闻APP进行评论');
      }
    } else {
      Toast('请填写评论内容');
    }
  }
}
